// CartContext.js
import React, { createContext, useState, useEffect } from "react";
import { getCurrentStore, getCookie, setCookie, getLoginInfo } from "./common/functions";

export const CartContext = createContext();

export const CartProvider = ({ children }) => {
  const [shopCart, setShopCart] = useState(null);

  const [eventQty, setEventQty] = useState(0);

  const [updatingEventCart, setUpdatingEventCart] = useState(false);

  const [updatingShopCart, setUpdatingShopCart] = useState(false);

  // Cargar carrito desde localStorage o cookie
  useEffect(() => {
    let storedCart = null;
    let storedEventQty = null
    let eventId = getCookie(process.env.REACT_APP_ORG_NAME + "_eventId");
    try {

      if (eventId) {
        storedEventQty = Number(localStorage.getItem(process.env.REACT_APP_ORG_NAME + "_eventQty"))
        setEventQty(storedEventQty)
      }

    } catch (e) {
      console.warn("No eventQty", e);
      setEventQty(0)
      localStorage.setItem(process.env.REACT_APP_ORG_NAME + "_eventQty", 0);
    }

    try {
      storedCart = JSON.parse(
        localStorage.getItem(process.env.REACT_APP_ORG_NAME + "_activeCartV3")
      );
    } catch (e) {
      console.warn("Error parsing stored cart", e);
    }

    if (!storedCart) {
      let cartCookie =
        getCookie(process.env.REACT_APP_ORG_NAME + "_cartSessionsV3") || "[]";
      let dataTC = [];

      try {
        dataTC = JSON.parse(cartCookie);
      } catch (e) {
        console.warn("Error parsing cart cookie", e);
      }

      const currStr = getCurrentStore();
      const pos = dataTC.findIndex((item) => item.storeid === currStr);

      if (pos >= 0) {
        const tid = dataTC[pos].id;
        storedCart = {
          id: tid,
          userID: getLoginInfo().userId || -1,
          needCommit: false,
          products: [],
          discount: null,
          subtotal: null,
          total: null,
        };
        //console.log("Creating cart...", storedCart);
        setShopCart(storedCart);
      } else {
        console.log("Store not found in cookies");
      }
    } else {
      setShopCart(storedCart);
      //console.log("Loading cart from localStorage...", storedCart);
    }

  }, []);

  // Guardar carrito en localStorage cuando cambie
  useEffect(() => {
    if (!updatingShopCart && shopCart) {
      console.log("Saving cart...", updatingShopCart);
      localStorage.setItem(
        process.env.REACT_APP_ORG_NAME + "_activeCartV3",
        JSON.stringify(shopCart)
      );
    } else {
      //console.log("espera!!!");
    }
  }, [shopCart, updatingShopCart]);

  // 🔄 Sincronizar carrito entre pestañas
  useEffect(() => {
    const handleStorageChange = (event) => {
      //Para manejar cambios en carrito
      if (event.key === process.env.REACT_APP_ORG_NAME + "_activeCartV3") {
        try {
          const newCart = JSON.parse(event.newValue);
          if (newCart) {
            console.log("🔄 Carrito sincronizado desde otra pestaña:", newCart);
            setUpdatingShopCart(true);
            setShopCart(newCart);
            setTimeout(() => setUpdatingShopCart(false), 100); // pequeña pausa para evitar reloop
          }
        } catch (e) {
          console.warn("Error al sincronizar carrito", e);
        }
      }
      //Para manejar cambios en evento
      if (event.key === process.env.REACT_APP_ORG_NAME + "_eventQty") {
        try {
          const newEventQty = JSON.parse(event.newValue);
          if (newEventQty) {
            console.log("🔄 Evento sincronizado desde otra pestaña:", newEventQty);
            setUpdatingEventCart(true);
            setEventQty(newEventQty);
            setTimeout(() => setUpdatingEventCart(false), 100); // pequeña pausa para evitar reloop
          }
        } catch (e) {
          console.warn("Error al sincronizar carrito", e);
        }
      }

    };

    window.addEventListener("storage", handleStorageChange);
    return () => window.removeEventListener("storage", handleStorageChange);
  }, []);


  // Guardar evento en localStorage cuando cambie
  useEffect(() => {
    if (!updatingEventCart && eventQty) {
      console.log("Saving event...", updatingEventCart);
      localStorage.setItem(
        process.env.REACT_APP_ORG_NAME + "_eventQty", eventQty
      );
    } else {
      //console.log("espera!!!");
    }
  }, [eventQty, updatingEventCart]);



  // Función: Agregar producto al carrito
  const addToCart = (product) => {
    setShopCart((prevCart) => {
      if (!prevCart) return null;
      const updatedProducts = [...prevCart.products, product];
      return { ...prevCart, products: updatedProducts };
    });
  };

  // Función: Eliminar producto por ID
  const removeFromCart = (productId) => {
    setShopCart((prevCart) => {
      if (!prevCart) return null;
      const updatedProducts = prevCart.products.filter(
        (p) => p.productid !== productId
      );
      return { ...prevCart, products: updatedProducts };
    });
  };

  // Función: Limpiar carrito
  const clearCart = () => {
    setShopCart((prevCart) => {
      if (!prevCart) return null;
      return {
        ...prevCart,
        products: [],
        discount: null,
        subtotal: null,
        total: null,
      };
    });
  };

  return (
    <CartContext.Provider
      value={{
        shopCart,
        setShopCart,
        addToCart,
        removeFromCart,
        clearCart,
        updatingShopCart,
        setUpdatingShopCart,

        eventQty,
        setEventQty,
        updatingEventCart,
        setUpdatingEventCart,

      }}
    >
      {children}
    </CartContext.Provider>
  );
};
